<template>
  <el-cascader
    class="department-cascade"
    v-model="selected"
    v-bind="$attrs"
    filterable
    clearable
    :options="$store.state.global.departments"
    checkStrictly
    @change="change"
    :props="{ checkStrictly: true }"
    ref="cascader"
  ></el-cascader>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      selected: []
    }
  },
  watch: {
    value (val) {
      this.selected = val
    }
  },
  created () {
    this.$store.dispatch('fetchDepartments').then(jobs => { })
  },
  methods: {
    change (val) {
      this.$emit('input', val)
      this.$refs.cascader && (this.$refs.cascader.dropDownVisible = false) // 监听值发生变化就关闭它
    }
  }
}
</script>

<style lang="scss" >
</style>
